import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { debounceTime, delay, tap } from 'rxjs/operators';
import { BaseGeneralComponent } from 'src/app/BaseGeneralComponent';
import { DialogDetailComponent } from 'src/app/general-components/dialog-detail/dialog-detail.component';
import { ContractTypeService } from 'src/app/general-services/service-contract-type/contract-type.service';
import { LoaderService } from 'src/app/general-services/service-loader/loader.service';
import { NumAnnoMeseService } from 'src/app/general-services/service-num-anno-mese/num-anno-mese.service';
import { ConsuntivoVolumiScartoService } from 'src/app/monthly-actual/consuntivo-volumi-scarto/service-consuntivo-volumi-scarto/consuntivo-volumi-scarto.service';
import { ContractTypeModel } from 'src/models/ContractTypeModel';
import { GenericArray } from 'src/models/GenericArray';
import { Offset } from 'src/models/Offset';
import { ProviderModel } from 'src/models/ProviderModel';
import { ScartiConsuntivoVolumiModel } from 'src/models/ScartiConsuntivoVolumiModel';
import { BandwidthScartoService } from './service-bandwidth-scarto/bandwidth-scarto.service';

@Component({
  selector: 'app-bandwidth-scarto',
  templateUrl: './bandwidth-scarto.component.html',
  styleUrls: ['./bandwidth-scarto.component.scss']
})
export class BandwidthScartoComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  getFirtsYearSubscribe: Subscription;
  getFirtsYearObservable: Observable<any>;

  displayedColumns: Array<string>;
  dataSource: any;
  showFilter = true;
  listData: MatTableDataSource<any>;
  offset: Offset;
  filter: ScartiConsuntivoVolumiModel;
  numAnnoMeseData: any;

  providerSelected: ProviderModel;

  isConsumptiveWasteSection: boolean;
  selectedRowIndex: number;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() reportSection?: boolean;
  @Output() elementSelected = new EventEmitter();
  
  constructor(private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private consuntivoVolumiScartoService: ConsuntivoVolumiScartoService,
              private bandwidthScartoService: BandwidthScartoService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;


    //  if (this.providerSelected.description.includes(this.PROVIDER_KYN)) {
    //   this.displayedColumns = ['numAnnoMeseComp', 'IsClaims','regionDesc','ruId','ruName','currencyCod','regionalBMV','bmUr','bandwidth1','bandwidth2'
    //   ,'actualVolume','actualBandwidth', 'calculateActualBandwidth','review','errors'];
    //  }
    this.displayedColumns = ['serviceDate', 'errors'];
    //this.filter = null;
               }

  ngOnInit() {
    this.isConsumptiveWasteSection = this.returnIsContractSection(this.router.url);
    this.selectedRowIndex = -1;
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.SCARTI_CONSUNTIVO_VOLUMI_OFFSET);
    this.filter = new ScartiConsuntivoVolumiModel();
    this.getFirtsYearObservable = this.numAnnoMeseService.getAllMonth(this.providerSelected, new ContractTypeModel()).pipe();
    this.manageForkJoin(this.getFirtsYearObservable, this.offset);
  }

  manageForkJoin(getFirtsYearSubscribe: Observable<any>, offset: Offset) {
    this.loaderService.display(false);
    forkJoin([getFirtsYearSubscribe]).subscribe(
      (resultFork: any) => {
          const providerDefault =
            JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
          this.numAnnoMeseData = this.filterFromDxc(providerDefault, resultFork[0] ? resultFork[0] : null);

          this.filter.providerCod =  this.providerSelected.cod;
          if (!this.filter.numAnnoMese) {
            this.numAnnoMeseService.getLastConsumptiveVolMonth(this.providerSelected).subscribe(
              res => {
                this.filter.numAnnoMese = res;
                this.getDataPage(this.offset, this.filter);
                if (this.reportSection) {
                  this.showFilter = true;
                }
              }
            );
          } else {
            if (!this.reportSection) {
              // this.showFilter = false;
              this.getDataPage(this.offset, this.filter);
            } else {
              this.showFilter = true;
            }
            this.showFilter = true;
          }
        }, error => {
        console.log(error);
        this.loaderService.display(false);
      });
  }

  getDataPage(offset: Offset, filter: ScartiConsuntivoVolumiModel) {
    this.loaderService.display(true);
    this.getPageSubscribe = this.bandwidthScartoService.getPage(offset, filter)
    .pipe(
      tap(() => this.loaderService.display(true)),
      debounceTime(0),
      delay(0),
      tap(() => this.loaderService.display(false)),
    ).subscribe(
        (resultPage: any) => {
          this.dataSource = resultPage.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = resultPage.totalElements;
          this.listData.sort = this.sort;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const consuntivoVolumi = this.dataSource.find(data => data.id === id) as ScartiConsuntivoVolumiModel;

    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(consuntivoVolumi.numAnnoMese)},
      {id: 'Reference Month ', value: this.toCustomStringAnnoMese(consuntivoVolumi.numAnnoMeseRif)},
      {id: 'Billed Month ', value: this.toCustomStringAnnoMese(consuntivoVolumi.numAnnoMeseBilled)},
      {id: 'Provider Cod', value: this.toCustomString(consuntivoVolumi.providerCod)},
      {id: 'Region Cod', value: this.toCustomString(consuntivoVolumi.regionCod)},
      {id: 'Local Customer Cod', value: this.toCustomString(consuntivoVolumi.localCustomerCod)},
      {id: 'Contract Type Cod', value: this.toCustomString(consuntivoVolumi.contractCod)},
      {id: 'Resource Unit Cod', value: this.toCustomString(consuntivoVolumi.resourcesUnitCod)},
      {id: 'ShareName', value: this.toCustomString(consuntivoVolumi.shareName)},
      {id: 'Errors', value: this.toCustomString(consuntivoVolumi.errors)},
      {id: 'SL1 Cod', value: this.toCustomString(consuntivoVolumi.designCod)},
      {id: 'SL2 Cod', value: this.toCustomString(consuntivoVolumi.layerCod)},
      {id: 'SL3 Cod', value: this.toCustomString(consuntivoVolumi.l1Cod)},
      {id: 'SL4 Cod', value: this.toCustomString(consuntivoVolumi.l2Cod)},
      {id: 'SL5 Cod', value: this.toCustomString(consuntivoVolumi.l3Cod)},
      {id: 'Subsidary', value: this.toCustomString(consuntivoVolumi.subsidary)},
      {id: 'Serial Number', value: this.toCustomString(consuntivoVolumi.serialNumber)},
      {id: 'Sla Type', value: this.toCustomString(consuntivoVolumi.slaType)},
      {id: 'Ssru', value: this.toCustomString(consuntivoVolumi.ssru)},
      {id: 'Volume', value: this.toCustomString(consuntivoVolumi.vol)},
      {id: 'Unit', value: this.toCustomString(consuntivoVolumi.unit)},
      {id: 'Application Cod', value: this.toCustomString(consuntivoVolumi.applicationCod)},
      {id: 'Application Description', value: this.toCustomString(consuntivoVolumi.applicationDescription)}
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.SCARTI_CONSUNTIVO_VOLUMI_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }    }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
      if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
  }
}

}
